import React, { useEffect } from "react";
import NavbarVisitor from "../../Component/NavbarVisitor";
import Footer from "../../Component/Footer";

const BadgeShow = ({ prefix, badgeNo }) => {
  // Log prefix and badgeNo when component renders
  useEffect(() => {
    console.log("BadgeShow Component Rendered");
    console.log("Prefix:", prefix);
    console.log("Badge No:", badgeNo);
  }, [prefix, badgeNo]); // Runs when prefix or badgeNo changes

  return (
    <>
      <div className="container d-flex justify-content-center align-items-center min-vh-100 mb-5">
        <div className="card shadow-lg border-primary text-center p-4" style={{ width: "350px", borderRadius: "15px" }}>
          <h4 className="text-uppercase text-primary">Event Badge</h4>
          <hr />
          <div className="badge-container">
            <h5 className="text-muted">Badge No:</h5>
            <h2 className="fw-bold text-dark">{prefix}-{badgeNo}</h2>
          </div>
          <div className="mt-4">
            <img 
              src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${prefix}-${badgeNo}`} 
              alt="Badge QR Code" 
              className="img-fluid rounded"
            />
          </div>
          <p className="mt-3 text-muted">Scan the QR code for verification</p>
          {/* <button className="btn btn-primary mt-3">Download Badge</button> */}
        </div>
      </div>
    </>
  );
};

export default BadgeShow;
